import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import { fetchSellerProfile } from '@/shared/persistence/user';
import { queryKeys } from '@/shared/hooks/queries/queryKeys';

export const SELLER_PROFILE_STALE_TIME = minutesToMilliseconds(5);

export const sellerProfileQueryParams = {
  queryKey: queryKeys.sellerProfile,
  queryFn: fetchSellerProfile,
  staleTime: SELLER_PROFILE_STALE_TIME,
};
export const useSellerProfile = () => {
  const result = useQuery({
    ...sellerProfileQueryParams,
    select: (data) => data.profile,
  });

  return { user: result.data };
};
